import React from 'react';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import 'react-phone-input-2/lib/style.css';
import { useAuth0 } from '@auth0/auth0-react';
import '../styles/searchResults.css';

const SearchResults = () => {
    const navigate = useNavigate();
    const { getAccessTokenSilently } = useAuth0();
    const location = useLocation();
    const results = location.state?.results ?? [];
    const display = (v) => { if (v === null || v === undefined || v === "") return "-"; return v; };
    const getPatientTests = async (patientId) => {
        try {
            const token = await getAccessTokenSilently({ authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE } });

            const res = await fetch(
                `${process.env.REACT_APP_API_BASE_URI}/api/patients/${patientId}/visits`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!res.ok) {
                throw new Error(`Failed to fetch tests: ${res.status}`);
            }

            const data = await res.json();
            return data;
        } catch (err) {
            console.error("Error fetching patient tests:", err);
            return null;
        }
    };

    const handleRowClick = async (patient) => {
        const patientTests = await getPatientTests(patient.patient_id)
        navigate('/individualPatient', {
            state: { patient: patient, patientTests: patientTests }
        });
    };

    function getSex(index) {
    switch (index) {
      case "1":
        return "Male";
      case "2":
        return "Female";
      case "3":
        return "Trans Male";
      case "4":
        return "Trans Female";
      default:
        return "Not Provided";
    }
  }

  function getRace(index) {
    switch (index) {
      case "1":
        return "White";
      case "2":
        return "Black/African American";
      case "3":
        return "Hispanic/Latin-American";
      case "4":
        return "Native/Indigenous";
      case "5":
        return "Asian";
      case "6":
        return "Native Hawaiian/Pacific Islander";
      default:
        return 'Not Provided';
    }
  }

  function getEducationLevel(index) {
    switch (index) {
      case "1":
        return "Less than high school diploma";
      case "2":
        return "High School diploma/GED";
      case "3":
        return "Some college or trade school";
      case "4":
        return "Associate's degree";
      case "5":
        return "Bachelor's degree";
      case "6":
        return "Graduate/professional degree (M.D., Ph.D., J.D., etc.)";
      default:
        return 'Not Provided';
    }
  }

    return (
        <div className="search-results">
            <h2 className="search-results__title">Search Results</h2>
            <Button
                onClick={() => navigate(-1)}
                startIcon={<ArrowBackIcon />}
                variant="text"
                className="search-results__back-btn"
            >
                Back to Search
            </Button>

            <div className="search-results__wrapper">
                <table className="search-results__table">
                    <thead>
                        <tr>
                            <th className="search-results__th">Name</th>
                            <th className="search-results__th">Phone</th>
                            <th className="search-results__th">DOB</th>
                            <th className="search-results__th">Sex</th>
                            <th className="search-results__th">Race</th>
                            <th className="search-results__th">Education</th>
                            <th className="search-results__th">Address</th>
                        </tr>
                    </thead>

                    <tbody>
                        {results.length === 0 ? (
                            <tr>
                                <td
                                    colSpan={7}
                                    className="search-results__no-results"
                                >
                                    No results found
                                </td>
                            </tr>
                        ) : (
                            results.map((patient) => (
                                <tr
                                    key={patient.patient_id}
                                    onClick={() => handleRowClick(patient)}
                                    className="search-results__row"
                                >
                                    <td className="search-results__td">
                                        {display([patient.first_name, patient.middle_name, patient.last_name].filter(Boolean).join(" "))}
                                    </td>
                                    <td className="search-results__td">{display(patient.phone)}</td>
                                    <td className="search-results__td">{display(patient.dob)}</td>
                                    <td className="search-results__td">{display(getSex(patient.sex))}</td>
                                    <td className="search-results__td">{display(getRace(patient.race))}</td>
                                    <td className="search-results__td">{display(getEducationLevel(patient.highest_education_level))}</td>
                                    <td className="search-results__td" title={display(patient.street_address)}>
                                        {display(patient.street_address)}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SearchResults